import "./App.scss";
import "./i18next";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Main from "./app/pages/Main";
import ResetPassword from "./app/pages/ResetPassword";
import InitializeProvider from "./app/pages/InitializeProvider";
import SignUpProvider from "./app/pages/SignUpProvider";

import { useAppSelector } from "./app/store/hooks";
const App: React.FC = () => {
  const settingsState = useAppSelector((state: any) => state.settings);
  const { i18n } = useTranslation();

  const changeLanguageHandler = (lang: string) => {
    let currLang = lang ?? "en";
    i18n.changeLanguage(currLang);
  };

  useEffect(() => {
    changeLanguageHandler(settingsState.lang);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Main />}></Route>
          <Route path="/signUpProvider" element={<SignUpProvider />}></Route>
<Route path="/reset-password" element={<ResetPassword />}></Route>
          <Route
            path="/initializeProvider"
            element={<InitializeProvider />}
          ></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
